const cwsCustomAddToCart = () => {
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
      if (e.target.closest("a[data-add-to-cart]")) {
        e.preventDefault();

        const btn = e.target.closest("[data-add-to-cart]");

        if (btn.classList.contains("btn-ajax-add--disabled")) {
          return;
        }

        const thisBtn = btn;
        const parent = thisBtn.parentNode.parentNode;
        const qty = 1;
        const productId = thisBtn.getAttribute("data-id");
        const errorMsg = parent.querySelector(".add-to-cart-ajax__error");
        const loader = parent.querySelector("[data-loader]");
        const txt = parent.querySelector("[data-txt]");
        const disabledClassName = "btn-ajax-add--disabled";
        ("btn-ajax-add--disabled");
        const request = {
          method: "POST",
          headers: {
            "Content-Type": "application/json;",
          },
          body: JSON.stringify({
            quantity: qty,
            id: productId,
          }),
        };

        thisBtn.classList.add(disabledClassName);
        txt.classList.add("hide");
        loader.classList.remove("hide");

        fetch("/cart/add.js", request)
          .then((response) => {
            return response.json();
          })
          .then((product) => {
            fetch("/cart.js")
              .then((response) => {
                return response.json();
              })
              .then((cart) => {
                const img = document.createElement("img");
                const imgBox = document.querySelector(
                  "[data-cart-popup-image-wrapper]"
                );
                const imgBoxWrapper = document.querySelector(
                  ".cart-popup-item__image-wrapper"
                );
                const cartPopup = document.querySelector(".cart-popup-wrapper");
                // const cartPopupTitle = cartPopup.querySelector(
                //   "[data-cart-popup-title]"
                // );
                // const cartPopupQty = cartPopup.querySelector(
                //   "[data-cart-popup-cart-quantity]"
                // );
                const cartCountBox = document.querySelector(
                  "[data-cart-count-bubble]"
                );
                const cartCount = document.querySelector("[data-cart-count]");

                // if (cartCountBox.classList.contains("hide"))
                //   cartCountBox.classList.remove("hide");

                cartCount.textContent = cart.item_count;
                // cartPopupQty.textContent = cart.item_count;

                // imgBox.innerHTML = null;

                // img.setAttribute("src", product.image);
                // img.setAttribute("alt", product.product_title);

                // cartPopup.classList.remove("cart-popup-wrapper--hidden");
                // document.querySelector("[data-cart-popup-quantity]").innerHTML =
                //   qty;

                loader.classList.add("hide");
                txt.classList.remove("hide");
                txt.textContent = "Added";

                setTimeout(() => {
                  txt.textContent = "Add to cart";
                  thisBtn.classList.remove(disabledClassName);
                }, 500);

                // cartPopupTitle.innerHTML = product.product_title;
                // imgBox.append(img);
                // imgBoxWrapper.classList.remove("hide");

                // document.addEventListener("click", function () {
                //   cartPopup.classList.add("cart-popup-wrapper--hidden");
                //   imgBox.innerHTML = null;
                //   imgBoxWrapper.classList.add("hide");
                // });
              });
          })
          .catch((response) => {
            errorMsg.textContent = response;
          });
      }
    });
  });
};

cwsCustomAddToCart();
